import { Select } from 'antd';
import React, { forwardRef } from 'react';

import {
  filterSelectOption,
  getOptionSearch,
  getOptionText,
  isDefinedValue,
} from './utils';

const { Option: SelectOption } = Select;

export const AddressSelect = forwardRef(function AddressSelect(
  {
    className,
    disabled,
    id,
    label,
    loading,
    multiple,
    name,
    options = [],
    value,
    onChange,
  },
  ref
) {
  const selectValue = multiple
    ? Array.isArray(value)
      ? value
      : []
    : Array.isArray(value)
    ? value[0]
    : value;

  const handleChange = (nextValue) => {
    if (typeof onChange !== 'function') {
      return;
    }

    if (multiple) {
      onChange(nextValue || []);
      return;
    }

    onChange(isDefinedValue(nextValue) ? [nextValue] : []);
  };

  return (
    <Select
      ref={ref}
      className={className}
      disabled={disabled}
      id={id}
      loading={loading}
      name={name}
      value={selectValue}
      mode={multiple ? 'multiple' : undefined}
      allowClear
      showSearch
      placeholder={label}
      optionFilterProp="search"
      optionLabelProp="label"
      filterOption={filterSelectOption}
      onChange={handleChange}
    >
      {options.map((option) => {
        const optionText = getOptionText(option);

        return (
          <SelectOption
            key={option.key ?? option.value}
            value={option.value}
            disabled={option.disabled}
            search={getOptionSearch(option)}
            label={optionText}
          >
            {option.content || optionText}
          </SelectOption>
        );
      })}
    </Select>
  );
});
